import * as z from 'zod';

export const FeedbackFormValidationSchema = z.object({
  name: z.string().min(1),
  email: z.string().email().min(1),
  message: z.string().min(1)
});

export type FeedbackFormValidationSchemaType = z.infer<typeof FeedbackFormValidationSchema>;
